import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { SectionEyebrow } from "./Reveal";
import { FAQS } from "../../data";

export const FAQ = () => (
  <section id="faq" className="bg-white py-20 md:py-28" data-testid="faq">
    <div className="container-oyf grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <SectionEyebrow>Questions & Answers</SectionEyebrow>
        <h2 className="font-display font-extrabold text-oyf-black tracking-tight text-3xl md:text-5xl leading-[1.02]">
          Frequently Asked Questions
        </h2>
        <p className="mt-5 text-oyf-medgrey leading-relaxed">
          Everything you need to know about expedited cargo-van freight and Canada–U.S. cross-border coordination.
        </p>
      </div>
      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-oyf-grey">
              <AccordionTrigger className="text-left font-display font-bold text-oyf-black text-base md:text-lg hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-oyf-medgrey text-[15px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
